export default "__VITE_ASSET__5fbdddc7__"